import { FieldType, ViewModelBase, isEmptyOrWhitespace } from "@shoothill/core";
import { runInAction, observable, action } from "mobx";
import { RDDV2FileModel, RDDV2FileRequestDTO } from "./RDDV2FileModel";
import { RDDV2FormFileModel } from "../../Forms/Common/RDDV2FormFileModel";
import { AppUrls } from "AppUrls";
import { ServerViewModel } from "Globals/ViewModels/ServerViewModel";

export class RDDV2FileViewModel extends ViewModelBase<RDDV2FileModel> {
    public constructor(rddV2Id: string | null) {
        super(new RDDV2FileModel(), false);
        this.setDecorators(RDDV2FileModel);
        this.model.rddV2Id = rddV2Id!;
        if (!isEmptyOrWhitespace(this.model.rddV2Id)) {
            this.loadRDDV2Files();
        }
    }

    public server: ServerViewModel = new ServerViewModel();

    @observable
    public files = observable<RDDV2FormFileModel>([]);

    /**
     * Download a file that exists in azure.
     * @param fileUrl The URL of the file to be downloaded.
     * @param fileName The name of the file to be downloaded.
     */
    public DownloadFile = async (fileUrl: string, fileName: string): Promise<void> => {
        try {
            const apiResult = await this.Post<Blob>(AppUrls.Server.File.DownloadFile, fileUrl, undefined, { responseType: "blob" });
            const response = apiResult as any;
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
        } catch (exception) {
            console.error(exception);
            this.setIsErrored(true);
        }
    };

    @action
    public loadRDDV2Files = async (): Promise<void> => {
        const request: RDDV2FileRequestDTO = {
            id: this.model.rddV2Id,
        };
        let apiResult = await this.Post<any>(AppUrls.Server.Projects.ProjectTrackers.RDDV2.GetRDDV2FilesById, request);
        if (apiResult) {
            if (apiResult.wasSuccessful) {
                if (apiResult.wasSuccessful) {
                    runInAction(() => {
                        this.files.replace(apiResult.payload);
                    });
                } else {
                    console.log(apiResult.errors);
                }
            }
        }
    };

    public async isFieldValid(fieldName: keyof FieldType<RDDV2FileModel>): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        errorMessage = "";
        isValid = true;

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
